import CONNECTORS from './connectors.gql';

export { CONNECTORS };
